import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';
import { Navigate } from 'react-router-dom';
import { JIRA_BOARDS_TAB_FEATURE_FLAG } from '../../featureFlags/uptime';
import { JiraBoardsPage } from './JiraBoardsPage';

export function JiraBoardsRoute() {
  const featureFlags = useApi(featureFlagsApiRef);

  if (!featureFlags.isActive(JIRA_BOARDS_TAB_FEATURE_FLAG)) {
    return <Navigate to="/catalog" replace />;
  }

  return <JiraBoardsPage />;
}
